import { useDeleteSalebill } from "http-hooks/salebill/useSalebill";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteSaleBill({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteSalebill();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Sale Bill"
      description="Are you sure you want to delete this sale bill? This sale bill will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
